import { NgModule } from '@angular/core';
import { FiContenteditableSimpleTextPanelHandlerDirective } from './fi-contenteditable-simple-text-panel-handler.directive';
import { FiContenteditableSimpleTextPanelRootDirective } from './fi-contenteditable-simple-text-panel-root.directive';
import { FiContenteditableSimpleTextPanelRootRefComponent } from './fi-contenteditable-simple-text-panel-root-ref.component';

@NgModule({
    declarations: [
        FiContenteditableSimpleTextPanelHandlerDirective,
        FiContenteditableSimpleTextPanelRootDirective,
        FiContenteditableSimpleTextPanelRootRefComponent,
    ],
    exports: [
        FiContenteditableSimpleTextPanelHandlerDirective,
        FiContenteditableSimpleTextPanelRootDirective,
        FiContenteditableSimpleTextPanelRootRefComponent,
    ],
})
export class FiContenteditableSimpleTextPanelHandlerModule {}
